const files = {
    batchImportTemplate:
        // eslint-disable-next-line max-len
        'https://demeterdevelopment.blob.core.windows.net/files/Import_Users_StoneX_Plus.csv?sp=r&st=2025-11-12T05:00:00Z&se=2100-11-13T04:59:59Z&spr=https&sv=2024-11-04&sr=b&sig=wIq%2FXTrBNK5CZ5plz3nAD5KcNHXrElI0ul%2BqQ2Klw68%3D',
    expanaUserAgreement:
        // eslint-disable-next-line max-len
        'https://demeterdevelopment.blob.core.windows.net/files/Expana%20EULA.pdf?sp=r&st=2025-11-12T05:00:00Z&se=2101-01-01T04:59:59Z&spr=https&sv=2024-11-04&sr=b&sig=wtFRKXhPOBfyfemDiuPR5FcDlGoGmKCymwv2ysPyeWE%3D',
};

export default files;
